import { useContext } from 'react';

import type { SemanticHeadingBaseLevel } from './SemanticHeading.types';
import SemanticHeadingBaseLevelContext from './SemanticHeadingBaseLevelContext';

export const useSemanticHeadingBaseLevelContext: () => SemanticHeadingBaseLevel = () =>
  useContext(SemanticHeadingBaseLevelContext);
